import React from "react";
import Sidebar from '../Sidebar/Sidebar';
import Testimonial from '../Testimonial/Testimonial';
import Bio from '../Bio/Bio';
// import ProductData from "./ProductData";
import Deals from './DayDeals';
import BestSelling from "../BestSelling/BestSelling";
import TrendingProducts from "../TrendingProducts/TrendingProducts";
import NewProducts from "../NewProducts/NewProducts";

const ProductContent = () => {
  return (
    <>
      <section className="productContent">
        <div className="container">
          <div className="row">
            <div className="col-full">
              <div className="product-contents">
                <div className="sidebar-data">
                  <Sidebar />
                  <Testimonial />
                  <Bio />
                </div>
                <div className="product-data">
                  {/* <Deals /> */}
                  <BestSelling />
                  <TrendingProducts />
                  <NewProducts />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ProductContent;
